export const tourSteps = [
  {
    element: '[data-intro="contact-requests-table"]',
    intro: "This table displays contact requests from users who have submitted enquiries through the diet recommendation system. Click on column headers to sort by different fields.",
    position: 'top'
  },
  {
    element: '[data-intro="download-button"]',
    intro: "Download the filtered contact requests as Excel (.xlsx) or CSV file. The download includes all matching requests based on your current filters, not just the current page.",
    position: 'bottom'
  },
  {
    element: '[data-intro="pagination"]',
    intro: "Navigate through pages of results and adjust the number of items displayed per page. Use the arrows to move between pages.",
    position: 'top'
  },
  {
    element: '[data-intro="filter-toggle"]',
    intro: "Click here to show or hide the filter options. Use filters to narrow down results by date range, country, user details, and more.",
    position: 'top'
  }
];
